import i18n from '../../managers/i18n'

i18n.register(
  'en-US',
  {
    close: 'Close',
    ok: 'OK',
    cancel: 'Cancel'
  },
  {
    ns: 'dialog'
  }
)
